import React, { lazy, Suspense, useEffect } from 'react'
import Buffering from './Buffering';
// import ArticlesContent from './ArticlesContent'
// import PageHeader from './PageHeader';

const PageHeader = lazy(()=>import("./PageHeader"));
const ArticlesContent = lazy(()=>import("./ArticlesContent"));

export default function Articles() {
  useEffect(()=>{
      window.scrollTo(0,0);
  },[]);

  return (
    <div className='col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 row px-0 display-flex'>
      <Suspense fallback={<Buffering />}>
      
      <PageHeader title="Articles" endPoint = "ARTICLES" />
        <ArticlesContent />
      </Suspense>
        
    </div>
  )
}
